import { render, staticRenderFns } from "./App.vue?vue&type=template&id=6eae32a0&"
var script = {}
import style0 from "@/sass/main.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports